<template>
  <v-container grid-list-xl>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <div v-if="!loading">
      <v-layout wrap v-if="jobOrders.length">
        <v-flex xs12 class="headline mb-4">
          <v-btn
            color="primary"
            class="mr-4"
            small
            outlined
            text
            to="/jobs"
            style="margin-top:-3px"
            ><v-icon>chevron_left</v-icon>JOBS</v-btn
          >
          {{ jobOrders[0].jobSite.street }}
          <v-btn
            class="ml-4"
            x-small
            outlined
            color="primary"
            :to="`/jobs/orders/${jobOrders[0].jobSite.id}`"
            >View Order Summary</v-btn
          >
          <v-btn
            class="ml-4"
            x-small
            outlined
            color="primary"
            :to="`/jobs/pickups/${jobOrders[0].jobSite.id}`"
            >View Pickup Summary</v-btn
          >
          <v-btn
            class="ml-4"
            x-small
            outlined
            color="primary"
            :to="`/jobs/gallery/${jobOrders[0].jobSite.id}`"
            >View Photo Gallery</v-btn
          >
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on }">
              <v-btn class="ml-4" x-small outlined v-on="on" color="blue"
                >Create cost adjustment</v-btn
              >
            </template>

            <v-card>
              <v-card-title>
                Create Cost Adjustment
              </v-card-title>

              <v-card-text class="px-2">
                <v-container fluid>
                  <v-row>
                    <v-col class="py-0">
                      <p class="mb-0 pb-0"></p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" xs="12" sm="6">
                      <v-select
                        label="Adjustment Type"
                        :items="['Returned Consumables']"
                        v-model="adjustmentType"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6">
                      <v-text-field
                        label="Adjustment Amount"
                        type="number"
                        v-model.number="adjustmentAmount"
                        persistent-hint
                        :hint="adjustmentAmount | currency"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" xs="12">
                      <p v-if="adjustmentType == 'Returned Consumables'">
                        * This amount will be deducted from the total
                        consumables cost (including yard cost). <br />List the
                        consumables returned, by who, and when they were
                        returned.
                      </p>
                      <v-textarea
                        label="Notes"
                        v-model="adjustmentNote"
                        outlined
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" text>
                  Cancel
                </v-btn>
                <v-btn
                  class="ml-4"
                  color="primary"
                  @click="createAdjustment"
                  :disabled="submittingAdjustment"
                >
                  Create
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!-- charts -->
        <v-flex xs12 sm6 md3>
          <v-card class="mt-4 mx-auto">
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="orange"
              elevation="10"
              max-width="calc(100% - 32px)"
            >
              <v-card dark color="primary">
                <v-card-text class="text-center headline">
                  ${{ numberWithCommas(stats.totalConsumablesCost.toFixed(2)) }}
                </v-card-text>
              </v-card>
            </v-sheet>
            <v-card-text class="pt-0">
              <div class="title font-weight-light text-center mb-2">
                Consumables Cost
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-card class="mt-4 mx-auto">
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="orange"
              elevation="10"
              max-width="calc(100% - 32px)"
            >
              <v-card dark color="primary">
                <v-card-text class="text-center headline">
                  ${{
                    numberWithCommas(stats.totalConsumablesCostYard.toFixed(2))
                  }}
                </v-card-text>
              </v-card>
            </v-sheet>
            <v-card-text class="pt-0">
              <div class="title font-weight-light text-center mb-2">
                Yard Consumables Cost
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-card class="mt-4 mx-auto">
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="orange"
              elevation="10"
              max-width="calc(100% - 32px)"
            >
              <v-card dark color="primary">
                <v-card-text class="text-center headline">
                  ${{
                    numberWithCommas(totalNonConsumableRentalCost.toFixed(2))
                  }}
                </v-card-text>
              </v-card>
            </v-sheet>
            <v-card-text class="pt-0">
              <div class="title font-weight-light text-center mb-2">
                Asset Rental Cost
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-card class="mt-4 mx-auto">
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="orange"
              elevation="10"
              max-width="calc(100% - 32px)"
            >
              <v-card dark color="primary">
                <v-card-text class="text-center headline">
                  {{ workersSummary.count || 0 }}
                  <span v-if="job.manDays">of {{ job.manDays }}</span>
                </v-card-text>
              </v-card>
            </v-sheet>
            <v-card-text class="pt-0">
              <div class="title font-weight-light text-center mb-2">
                Man Days
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="job.adjustments">
          <v-card>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Adjustment
                    </th>
                    <th class="text-left">
                      Amount
                    </th>
                    <th class="text-left">
                      Note
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(val, key) in job.adjustments" :key="key">
                    <td>
                      {{ val.adjustmentType }}
                    </td>
                    <td>
                      <strong
                        >${{ numberWithCommas(val.adjustmentAmount) }}</strong
                      >
                    </td>
                    <td>
                      {{ val.adjustmentNote }}
                      <div class="caption grey--text">
                        submitted by {{ val.adjustmentBy.firstName }}
                        {{ val.adjustmentBy.lastName }} on
                        {{
                          val.createDate.toDate() | moment("MMM Do [at] h:mma")
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-flex>

        <!-- worker activity -->
        <v-flex xs12 md6>
          <v-card>
            <h3 class="pa-3 pb-2 primary white--text">
              Worker Activity (only punch ins{{
                workersAllLoaded ? "" : ", last 30 days"
              }})
            </h3>
            <v-data-table
              dense
              :headers="payrollHeaders"
              :items="workersSummary.punchRecords"
              :items-per-page="10"
              :search="searchWorkers"
              :custom-filter="workersFilter"
            >
              <template v-slot:top>
                <v-toolbar flat color="white" class="pt-1">
                  <v-text-field
                    v-model="searchWorkers"
                    dense
                    label="Filter"
                    hide-details
                    outlined
                    clearable
                  ></v-text-field>
                  <v-btn
                    v-if="!workersAllLoaded"
                    class="ml-3"
                    small
                    outlined
                    color="primary"
                    :loading="loadingAllWorkers"
                    @click="loadAllWorkers"
                    >Load all</v-btn
                  >
                </v-toolbar>
              </template>
              <template v-slot:item.name="{ item }">
                {{ item.firstName }} {{ item.lastName }}
              </template>
              <template v-slot:item.punchIn="{ item }">
                {{ item.time.toDate() | moment("h:mm a on MMM Do YYYY") }}
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
        <!-- job details -->
        <v-flex xs12 md6>
          <v-card>
            <h3 class="pa-3 pb-2 primary white--text">
              Job Details
            </h3>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td><strong>Address</strong></td>
                    <td>
                      {{ job.address }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Job ID</strong></td>
                    <td>
                      {{ job.jobId }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Proposal Number</strong></td>
                    <td>
                      {{ job.proposalNumber }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Estimator</strong></td>
                    <td>
                      {{ job.estimator ? job.estimator.name : "None Selected" }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Date Awarded</strong></td>
                    <td>
                      <span v-if="job.dateAwarded"
                        >{{ job.dateAwarded | moment("MMM Do, YYYY") }}
                      </span>
                      <span v-else>-</span>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Department</strong></td>
                    <td>
                      {{ job.department.join(", ") }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Project Managers</strong></td>
                    <td>
                      <div v-if="job.projectManagers">
                        {{
                          job.projectManagers.map((pm) => pm.name).join(", ")
                        }}
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td><strong>Contract Value</strong></td>
                    <td>
                      {{ job.contractValue | currency }}
                      <div
                        class="caption grey--text"
                        v-if="job.scopeBreakdownNote"
                      >
                        {{ job.scopeBreakdownNote }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Total Budget</strong></td>
                    <td>
                      {{ job.totalBudget | currency }}
                      <div
                        class="caption grey--text"
                        v-if="job.totalBudgetNote"
                      >
                        {{ job.totalBudgetNote }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Estimated Budget - LABOR</strong></td>
                    <td>
                      {{ job.laborBudget | currency }}
                      {{ job.manDays ? `(${job.manDays} Man Days)` : "" }}
                      <div
                        class="caption grey--text"
                        v-if="job.laborBudgetNote"
                      >
                        {{ job.laborBudgetNote }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Estimated Budget - DUMPING</strong></td>
                    <td>
                      {{ job.dumpingBudget | currency }}
                      <div
                        class="caption grey--text"
                        v-if="job.dumpingBudgetNote"
                      >
                        {{ job.dumpingBudgetNote }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Estimated Budget - MATERIAL</strong></td>
                    <td>
                      {{ job.materialBudget | currency }}
                      <div
                        class="caption grey--text"
                        v-if="job.materialBudgetNote"
                      >
                        {{ job.materialBudgetNote }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Estimated Budget - CONSUMABLES</strong></td>
                    <td>
                      {{ job.consumablesBudget | currency }}
                      <div
                        class="caption grey--text"
                        v-if="job.consumablesBudgetNote"
                      >
                        {{ job.consumablesBudgetNote }}
                      </div>
                      <div
                        v-if="job.consumablesBudgetAlert"
                        class="caption grey--text"
                      >
                        <v-icon small color="grey">notifications</v-icon> An
                        email will be sent when the consumables cost reaches
                        {{ job.consumablesBudgetAlert | currency }}.
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Subcontractor Value</strong></td>
                    <td>
                      {{ job.subcontractorValue | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Estimated Timeframe</strong></td>
                    <td>
                      <span v-if="job.estimatedStartDate"
                        >{{ job.estimatedStartDate | moment("MMM Do, YYYY") }}
                      </span>
                      <span v-if="job.estimatedCompletionDate">
                        -
                        {{
                          job.estimatedCompletionDate | moment("MMM Do, YYYY")
                        }}
                      </span>
                      <div v-if="job.estimatedDays" class="grey--text">
                        Approximately {{ job.estimatedDays }} days
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Status</strong></td>
                    <td>
                      {{ job.status }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-flex>
        <!-- Tools Ordered -->
        <v-flex xs12>
          <v-card>
            <h3 class="pa-3 pb-2 primary white--text">Tools Summary</h3>
            <v-data-table
              :headers="headers"
              :items="stats.items"
              item-key="id"
              sort-by="totalCost"
              :items-per-page="20"
              sort-desc
            >
              <template v-slot:item.image="{ item }">
                <div class="py-1">
                  <v-img :src="item.image" width="60" height="60" contain />
                </div>
              </template>
              <template v-slot:item.consumable="{ item }">
                <v-chip color="grey lighten-3" small v-if="item.consumable"
                  >Consumable</v-chip
                >
                <v-chip color="red lighten-3" small v-else>Returnable</v-chip>
              </template>
              <template v-slot:item.totalQtyFulfilled="{ item }">
                <span
                  :class="{
                    hasDelta: item.totalQtyRequested > item.totalQtyFulfilled,
                  }"
                  >{{ item.totalQtyFulfilled }}</span
                >
                <!-- <span class="red--text caption">( -1 )</span> -->
              </template>
              <template v-slot:item.totalCost="{ item }">
                <strong>${{ item.totalCost }}</strong>
                <v-tooltip bottom v-if="!item.consumable && item.totalQtyFulfilled > 0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      color="grey"
                      class="ml-1"
                      v-bind="attrs"
                      v-on="on"
                    >
                      info
                    </v-icon>
                  </template>
                  <span>Asset Rental Cost: 10% of unit price × fulfilled quantity</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="mb-4">
            <h3 class="pa-3 pb-2 primary white--text">
              Dump Tickets
              <v-spacer></v-spacer>
              <span class="caption">TOTAL: {{ totalTons }} tons</span>
            </h3>
            <v-divider></v-divider>
            <v-data-table
              :items="truckRequests"
              :headers="truckRequestHeaders"
              disable-sort
              dense
              class="truckReportTable"
            >
              <template v-slot:item.createDate="{ item }">
                {{ item.createDate.toDate() | moment("MM/DD/YYYY") }}
              </template>
              <template v-slot:item.yards="{ item }">
                {{ item.yards }}
              </template>
              <template v-slot:item.loadWeight="{ item }">
                {{ item.loadWeight }}
                <span class="caption">{{ item.loadWeightType }}</span>
              </template>
              <template v-slot:item.dumpTicketImage="{ item }">
                <v-btn
                  icon
                  small
                  v-for="image of item.dumpTicketImage"
                  :key="image"
                  target="_blank"
                  :href="image"
                >
                  <v-icon small>image</v-icon>
                </v-btn>
              </template>
              <template v-slot:item.request="{ item }">
                <a
                  :href="`/truck-requests/manage/orders/${item.requestId}`"
                  target="_blank"
                  >view</a
                >
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-row justify="center" v-if="!loading">
          <v-col class="text-center mt-4 pt-4">
            No tool order data available for this job<br /><br />
            <v-btn color="primary" outlined to="/jobs"
              ><v-icon left>chevron_left</v-icon> Back to jobs</v-btn
            >
          </v-col>
        </v-row>
      </v-layout>
    </div>
    <div v-else>
      <h1 class="display-1 text-center">
        Loading Job Site Data
      </h1>
      <v-text-field color="primary" loading disabled></v-text-field>
    </div>
  </v-container>
</template>
<script>
import fb from "@/main";
import moment from "moment";
import { mapState } from "vuex";
import {
  countBy as _countBy,
  sum,
  sumBy,
  round,
  sortBy,
  uniq,
} from "lodash";
export default {
  data() {
    return {
      job: null,
      loading: true,
      dialog: false,
      adjustmentType: null,
      adjustmentNote: "",
      adjustmentAmount: 0,
      submittingAdjustment: false,
      jobOrders: [],
      labels: [],
      value: [],
      truckRequests: [],
      stats: {
        totalOrders: 0,
        items: [],
      },
      round,
      searchWorkers: "",
      truckRequestHeaders: [
        { text: "Date", value: "createDate", width: 110 },
        { text: "Yrds", value: "yards", width: "60" },
        { text: "Driver", value: "driverName" },
        { text: "Location", value: "dumpSite" },
        { text: "Load Weight", value: "loadWeight" },
        { text: "Image", value: "dumpTicketImage", width: "100" },
        { text: "Request", value: "request", width: "100", align: "center" },
      ],
      totalLbs: 0,
      totaTons: 0,
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "image",
          width: 50,
        },
        { text: "Title", value: "title" },
        {
          text: "Consumable",
          value: "consumable",
          width: "140",
          align: "center",
        },
        {
          text: "Requested",
          value: "totalQtyRequested",
          align: "center",
          width: "140",
        },
        {
          text: "Fulfilled",
          value: "totalQtyFulfilled",
          align: "center",
          width: "140",
        },
        {
          text: "Unit Price",
          value: "formattedUnitPrice",
          align: "center",
          width: "140",
        },
        {
          text: "Cost",
          value: "totalCost",
          align: "center",
          width: "140",
        },
      ],
      payrollHeaders: [
        {
          text: "Employee",
          align: "left",
          value: "name",
        },
        {
          text: "Punch In",
          align: "left",
          value: "punchIn",
        },
        {
          text: "Type",
          align: "left",
          value: "department",
        },
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      workersSummary: {},
      workersAllLoaded: false,
      loadingAllWorkers: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    totalNonConsumableRentalCost() {
      if (!this.stats.items || this.stats.items.length === 0) {
        return 0;
      }

      return this.stats.items.reduce((total, item) => {
        // Only calculate for non-consumable items (returnable tools)
        if (!item.consumable && item.totalQtyFulfilled > 0) {
          const unitPrice = parseFloat(item.unitPrice) || 0;
          const rentalCost = unitPrice * 0.1; // 10% of unit price
          const totalForItem = rentalCost * item.totalQtyFulfilled;
          return total + totalForItem;
        }
        return total;
      }, 0);
    },
  },
  async created() {
    this.getData();
    this.getWorkers();
    this.getTruckRequests();
  },
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async getConsumablesCostData() {
      try {
        const getJobConsumablesCost = fb.functions.httpsCallable(
          "getJobConsumablesCost"
        );
        const result = await getJobConsumablesCost({
          jobSiteId: this.$route.params.id,
        });
        return result.data;
      } catch (error) {
        throw error;
      }
    },
    async createAdjustment() {
      if (this.adjustmentType && this.adjustmentAmount && this.adjustmentNote) {
        try {
          this.submittingAdjustment = true;
          const payload = {};
          const id = `adjustments.${moment().unix()}`;
          payload[id] = {
            adjustmentType: this.adjustmentType,
            adjustmentAmount: this.adjustmentAmount,
            adjustmentNote: this.adjustmentNote,
            adjustmentBy: this.user,
            createDate: fb.timestamp,
          };
          await fb.db
            .collection("jobSites")
            .doc(this.$route.params.id)
            .update(payload);
          this.dialog = false;
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Successfully submitted adjustment";
          this.resetAdjustment();
          this.getData();
          this.submittingAdjustment = false;
        } catch (error) {
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Error submitting adjustment";
          this.submittingAdjustment = false;
        }
      } else {
        alert("missing information for adjustment.");
      }
    },
    resetAdjustment() {
      this.adjustmentType = null;
      this.adjustmentAmount = 0;
      this.adjustmentNote = "";
    },
    async getJob() {
      const job = await fb.db
        .collection("jobSites")
        .doc(this.$route.params.id)
        .get();
      this.job = job.data();
    },
    workersFilter(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLowerCase()
          .indexOf(search.toLowerCase()) !== -1
      );
    },
    async getData() {
      try {
        // Wait for the job too, or the page renders job.manDays while job is
        // still null whenever the cost call comes back first
        const [, response] = await Promise.all([
          this.getJob(),
          this.getConsumablesCostData(),
        ]);
        const costData = response.data;

        // Extract all data from server response
        this.jobOrders = costData.jobOrders || [];
        this.stats.items = costData.items || [];
        this.stats.totalConsumablesCost = costData.cost || 0;
        this.stats.totalConsumablesCostYard = costData.yardCost || 0;

        // Calculate rental costs for non-consumable items
        this.stats.items = this.stats.items.map(item => {
          if (!item.consumable && item.totalQtyFulfilled > 0) {
            const unitPrice = parseFloat(item.unitPrice) || 0;
            const rentalCost = unitPrice * 0.1; // 10% of unit price
            const totalRentalCost = rentalCost * item.totalQtyFulfilled;
            return {
              ...item,
              totalCost: totalRentalCost.toFixed(2)
            };
          }
          return item;
        });

        if (this.jobOrders.length) {
          // Build chart data from job orders
          const orderDates = this.jobOrders.map((jo) =>
            moment(jo.orderDate)
              .startOf("week")
              .format("M.D.YY")
          );
          const counts = _countBy(orderDates);
          const keys = Object.keys(counts);
          keys.forEach((k) => {
            this.labels.push(k);
            this.value.push(counts[k]);
          });

          this.value.reverse();
          this.labels.reverse();
          this.stats.totalOrders = sum(Object.values(counts));
        }
        this.loading = false;
      } catch (err) {
        alert("Error getting job data");
        this.loading = false;
      }
    },
    // Man days come from the nightly jobStats doc (every day before today) plus
    // today's punch-ins, and the activity table shows the last 30 days, so the
    // page no longer reads the job's full punch history on load.
    async getWorkers() {
      try {
        const jobSiteId = this.$route.params.id;
        const since = moment()
          .subtract(30, "days")
          .startOf("day");
        const [statsDoc, punchRes] = await Promise.all([
          fb.db
            .collection("jobStats")
            .doc(jobSiteId)
            .get()
            .catch(() => null),
          fb.db
            .collection("punchRecords")
            .where("time", ">=", since.toDate())
            .where("jobSite", "==", jobSiteId)
            .orderBy("time", "desc")
            .get(),
        ]);
        let punchRecords = [];
        punchRes.forEach((doc) => {
          if (doc.data().direction === "in") {
            punchRecords.push({ id: doc.id, ...doc.data() });
          }
        });
        const employeeDocs = await Promise.all(
          uniq(punchRecords.map((pr) => pr.employee)).map((id) =>
            fb.db
              .collection("employees")
              .doc(id)
              .get()
          )
        );
        const employees = {};
        employeeDocs.forEach((doc) => {
          if (doc.exists) {
            const data = doc.data();
            employees[doc.id] = {
              ...data,
              name: `${data.firstName} ${data.lastName}`,
            };
          }
        });
        punchRecords = punchRecords.map((pr) => ({
          ...employees[pr.employee],
          ...pr,
        }));

        let count = 0;
        if (statsDoc && statsDoc.exists) {
          const today = moment().format("YYYY-MM-DD");
          const days = statsDoc.data().days || {};
          const todayCount = uniq(
            punchRecords
              .filter(
                (pr) => moment(pr.time.toDate()).format("YYYY-MM-DD") === today
              )
              .map((pr) => pr.employee)
          ).length;
          count =
            sum(
              Object.keys(days)
                .filter((day) => day < today)
                .map((day) => days[day].manDays)
            ) + todayCount;
        } else {
          // Jobs with no punch-ins in the last 60 days have no jobStats doc yet.
          count = await this.$store.dispatch("manDaysCount", {
            fb: fb,
            jobId: jobSiteId,
          });
        }
        this.workersSummary = { count, punchRecords };
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log("getWorkers error", err);
      }
    },
    async loadAllWorkers() {
      this.loadingAllWorkers = true;
      const allWorkers = await this.$store.dispatch("getManDays", {
        fb: fb,
        jobId: this.$route.params.id,
      });
      if (allWorkers) {
        this.workersSummary = {
          ...this.workersSummary,
          punchRecords: allWorkers.punchRecords,
        };
        this.workersAllLoaded = true;
      }
      this.loadingAllWorkers = false;
    },
    async getTruckRequests() {
      const fbRes = await fb.db
        .collection("truckRequests")
        .where("status", "==", "closed")
        .where("jobSite.id", "==", this.$route.params.id)
        .orderBy("orderDate", "desc")
        .orderBy("dumpTickets", "asc")
        .get();
      var closedRequests = [];
      fbRes.forEach(function(doc) {
        closedRequests.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      const dumpTickets = [];
      closedRequests.forEach((tr) => {
        if (tr.dumpTickets) {
          const tickets = Object.values(tr.dumpTickets);
          dumpTickets.push(
            tickets.map((t) => {
              return {
                ...t,
                materialTypeBreakdown: tr.materialTypeBreakdown,
                jobSite: tr.jobSite,
                requestId: tr.orderNumber,
                orderDate: tr.orderDate,
                requestDate: tr.requestDate,
                driverName: `${tr.scheduledDriver.firstName} ${tr.scheduledDriver.lastName}`,
                client: tr.jobSite.jobId.startsWith("TR") ? "External" : "ALBA",
              };
            })
          );
        }
      });
      const allTickets = sortBy(dumpTickets.flat(), "requestDate").reverse();
      // If loadWeight > 100, then its pounds
      // ix loadWeight < 100, then its tons
      // calculate totalLbs by converting tons to lbs
      const totalLbs = sumBy(allTickets, (t) => {
        if (t.loadWeight > 100) {
          return t.loadWeight;
        } else {
          return t.loadWeight * 2000;
        }
      });
      // calculate total tons
      const totalTons = sumBy(allTickets, (t) => {
        if (t.loadWeight > 100) {
          return t.loadWeight / 2000;
        } else {
          return t.loadWeight;
        }
      });
      // assign to this and round to 2 decimal places
      this.totalLbs = round(totalLbs, 2);
      this.totalTons = round(totalTons, 2);
      this.truckRequests = allTickets;
    },
  },
};
</script>

<style scoped>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.hasDelta {
  border-bottom: solid#f17a8f 2px;
}
</style>
